import React from 'react';
import { useParams } from 'react-router-dom';
import {Row, Col} from 'react-bootstrap';
import Product from '../component/Product';
import Loader from '../component/Loader';
import { useGetProductsQuery } from '../slices/productApiSlice';
import Message from '../component/Message';
import Paginate from '../component/Paginate';
import ProductCarousel from '../component/ProductCarousel';
import { Link } from 'react-router-dom';


const localProxy = "http://localhost:8000"


const HomeScreen = () => {
  const {pageNumber, keyword} = useParams();
  const {data, isLoading, error} = useGetProductsQuery({keyword, pageNumber});

  return (
    <>
        {!keyword? <ProductCarousel/> : <Link to='/home' className='btn btn-light mb-4'>Go Back</Link>}
        {isLoading? (
          <Loader />
        ): error? (
            <Message variant='danger'>{error?.data?.message|| error.error}</Message>)
            : (
            <>
            <h1>Latest Product</h1>
              <Row>
            {data.products.map((product) => (
                <Col key={product._id} sm={12} md={6} lg={4} xl={3}>
                 <Product product={product} />
                </Col>
            ))}
             </Row>
             <Paginate 
               pages={data.pages}
               page={data.page}
               keyword ={keyword ? keyword: ''}
             />
          </>
          )}
      
    </>
  )
}

export default HomeScreen
